import { connect } from 'react-redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { post } from '../modules/user'
import { isAdmin } from 'helpers/auth'

import component from 'components/Users/New'

const formName = 'new-user'
const fields = [
  'email', 'password', 'timezone', 'rollover_offset', 'customers[].id', 'is_admin', 'can_special_order', 'send_order_confirmations'
]

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  onSubmit: (data) => {
    let initialValues = mapStateToProps({}, ownProps).initialValues

    dispatch(post(data))
    dispatch(reset(formName))
    dispatch(destroy(formName))
    dispatch(initialize(formName, initialValues, fields))
  }
})

const mapStateToProps = (state) => ({
  user: state.user,
  customers: state.customers,
  initialValues: {
    timezone: 'America/Los_Angeles',
    rollover_offset: -18,
    can_special_order: true,
    send_order_confirmations: true,
    customers: [{ id: undefined }]
  }
})

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}

    if (!state.password) {
      errors.password = 'Please enter a password.'
    } else if (state.password.length < 6) {
      errors.password = 'The password must be at least 6 characters long.'
    }

    if (!state.email) {
      errors.email = 'Please include an email address.'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(state.email)) {
      errors.email = 'Please enter a valid email address.'
    }

    if (isAdmin() && !state.is_admin) { // WARNING: isAdmin() may not be valid at all times..
      let isValid = (state.customers || []).some(customer => {
        if (customer && customer.id) return true
      })

      if (!isValid) errors._error = 'Users must have a customer associated with them.'
    }

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Users/containers/NewUserContainer.js